import {Component, inject, OnInit} from '@angular/core';
import {LabelComponent} from '../../../../shared/components/form/label/label.component';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {EditionButtons} from '../../../../shared/components/ui/edition-buttons/edition-buttons';
import {Router} from '@angular/router';
import {FormStatusService} from '../../../../shared/services/form-status.service';
import {PerfilService} from '../perfil.service';
import {SnackbarService} from '@shared/services/snackbar.service';
import {ErrorService} from '../../../../shared/services/error.service';

@Component({
  selector: 'app-cambiar-contrasenha',
  imports: [
    LabelComponent,
    FormsModule,
    ReactiveFormsModule,
    EditionButtons
  ],
  templateUrl: './cambiar-contrasenha.html'
})
export class CambiarContrasenha implements OnInit {

  loading = false;
  editable = true;
  saveForm!: FormGroup;
  showPasswordFields = {
    current_password: false,
    new_password: false,
    new_password_confirmation: false
  };

  private router = inject(Router);
  private fB = inject(FormBuilder);
  private fS = inject(FormStatusService);
  private perfilService = inject(PerfilService);
  private snackbarService = inject(SnackbarService);
  private errorService = inject(ErrorService);

  ngOnInit(): void {
    this.makeForm();
  }

  private makeForm() {
    this.saveForm = this.fB.group({
      current_password: [{value: '', disabled: this.editable}, Validators.required],
      new_password: [{value: '', disabled: this.editable}, [Validators.required, Validators.minLength(8)]],
      new_password_confirmation: [{value: '', disabled: this.editable}, [Validators.required, Validators.minLength(8)]]
    });
  }

  onSubmitChangePassword(): void {
    this.loading = true;
    this.perfilService.update(this.saveForm.value).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar("La contraseña se actualizó correctamente");
          this.onResetChagePasswordForm();
        }
      },
      error: error => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  togglePasswordVisibility(field: 'current_password' | 'new_password' | 'new_password_confirmation'): void {
    this.showPasswordFields[field] = !this.showPasswordFields[field];
  }

  editableSwitcher(): void {
    this.fS.changeStatus(this.saveForm, this.editable);
    this.editable = !this.editable;
  }

  goBack(): void {
    this.router.navigate([''], {replaceUrl: true});
  }

  onResetChagePasswordForm() : void {
    this.editableSwitcher();
    this.saveForm.reset();
  }

  get isPasswordMismatch(): boolean {
    const newPassword = this.saveForm.get('new_password')?.value;
    const newPasswordConfirmation = this.saveForm.get('new_password_confirmation')?.value;

    // Solo si ambos campos fueron cargados se evalúa
    if (!newPassword || !newPasswordConfirmation) return false;
    return newPassword !== newPasswordConfirmation;
  }
}
